<template>
  <v-dialog v-model="dialog" scrollable max-width="800px">
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>
    <v-card>
      <v-card-title>アイコンの選択</v-card-title>
      <v-divider></v-divider>
      <v-card-actions>
        <v-text-field
          autofocus
          class="mx-3"
          v-model="query"
          :loading="loading"
          label="アイコン名で検索"
          @input="filteredIcons"
        />
      </v-card-actions>
      <v-card-text class="row" style="height: 500px">
        <template v-for="(iconKey, index) in icons">
          <div
            v-if="findIconSet(iconKey).farIcon"
            :key="`${index}_far_${iconKey}`"
            class="d-flex col-2 text-center p-selectIcon"
            v-ripple
            style="cursor: pointer; height: 100px"
            @click="() => selectIcon(iconValue(findIconSet(iconKey).farIcon))"
          >
            <div class='ma-auto'>
              <div class="ma-auto">
                <font-awesome-icon
                  :icon="iconValue(findIconSet(iconKey).farIcon)"
                />
              </div>
              <span class="caption">
                {{ iconLabel(findIconSet(iconKey).farIcon) }}
              </span>
            </div>
          </div>
          <div
            v-if="findIconSet(iconKey).fasIcon"
            :key="`${index}_fas_${iconKey}`"
            class="d-flex col-2 text-center p-selectIcon"
            v-ripple
            style="cursor: pointer; height: 100px"
            @click="() => selectIcon(iconValue(findIconSet(iconKey).fasIcon))"
          >
            <div class='ma-auto'>
              <div class="ma-auto">
                <font-awesome-icon
                  :icon="iconValue(findIconSet(iconKey).fasIcon)"
                />
              </div>
              <span class="caption">
                {{ iconLabel(findIconSet(iconKey).fasIcon) }}
              </span>
            </div>
          </div>
        </template>
        <infinite-loading
          class="col-12"
          spinner="spiral"
          @infinite="infiniteHandler"
          :identifier="identifier"
        >
          <template v-slot:no-more>
            <v-chip class="mt-10" label color="teal" text-color="white">
              <v-avatar left>
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-avatar>
              全てのアイコンが表示されました
            </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip class="mt-10" label large color="amber" text-color="white">
              <v-avatar left>
                <v-icon>mdi-close-circle</v-icon>
              </v-avatar>
              アイコンが見つかりませんでした
            </v-chip>
          </template>
        </infinite-loading>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error darken-1" text @click="dialog = false">
          キャンセル
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { debounce } from 'lodash'

export default {
  name: 'SelectIconDialog',
  data () {
    return {
      dialog: false,
      page: 1,
      loading: false,
      query: '',
      icons: [],
      identifier: +new Date()
    }
  },
  computed: {
    maxIconSize () {
      return this.iconKeys.length
    },
    iconSize () {
      return this.icons.length
    },
    iconKeys () {
      return Object.keys({ ...fas, ...far }).filter(this.filterIconLabel)
    }
  },
  methods: {
    infiniteHandler ($state) {
      if (this.iconSize < this.maxIconSize) {
        this.page++
        this.fetchIcons($state)
      } else {
        $state.complete()
      }
    },
    filteredIcons () {
      this.page = 0
      this.icons = []
      this.loading = true
      this.identifier = +new Date()
      this.fetchIcons()
    },
    iconLabel (icon) {
      return icon.iconName
    },
    iconValue (icon) {
      return `${icon.prefix} fa-${icon.iconName}`
    },
    selectIcon (className) {
      this.$emit('select-icon', className)
      this.dialog = false
    },
    fetchIcons: debounce(function ($state = null) {
      this.icons = this.iconKeys.slice(0, 100 * this.page)
      if ($state && $state.loaded) $state.loaded()
      this.loading = false
    }, 800),
    findIconSet (iconName) {
      return { farIcon: far[iconName], fasIcon: fas[iconName] }
    },
    filterIconLabel (key) {
      const { farIcon, fasIcon } = this.findIconSet(key)
      return (
        !this.query ||
        (farIcon && this.iconLabel(farIcon).includes(this.query)) ||
        (fasIcon && this.iconLabel(fasIcon).includes(this.query))
      )
    }
  }
}
</script>

<style scoped>
.p-selectIcon:hover {
  background-color: rgba(100, 100, 100, 0.1);
}
</style>
